export enum ValidationMessages {
  EMAIL_REQUIRED = 'Email is required',
  FIRST_NAME_REQUIRED = 'First name is required',
  INVALID_EMAIL = 'Enter a valid email',
  LAST_NAME_REQUIRED = 'Last name is required',
  PASSWORD_REQUIRED = 'Password is required',
  PASSWORD_REQUIREMENT = 'Password needs to be strong (6+ characters, at least one upper and one lower case letter and a number)',
  PROFESSION_REQUIRED = 'Profession is required',
  PHONE_NUMBER_INVALID = 'Mobile number is not valid',
}
